import React, { Component } from 'react';
import { combineReducers } from 'redux';

import * as actions from './DiscoverHistorics.ducks';
import { default as Page } from './DiscoverHistorics.ducks';
import { default as HistoricsSearchForm } from './containers/HistoricsSearchForm/HistoricsSearchForm.ducks';

const reducer = combineReducers({
  Page,
  HistoricsSearchForm
});

class DiscoverLoader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      component: null
    };
  }

  // TODO: Update logic when migrating to React 17
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    return import(/* webpackChunkName: "zen/DiscoverHistorics.zen" */ './DiscoverHistorics')
      .then((DiscoverHistorics) => {
        this.setState({component: DiscoverHistorics.default});
      }).catch(
      // eslint-disable-next-line no-console
        (error) => console.error('An error occurred while loading \'Discover Historics\'',error)
      );
  }

  render () {
    return (
      <span>{this.state.component && (<this.state.component {...this.props} />)}</span>
    );
  }
}

export default DiscoverLoader;
export { default as sagas } from './DiscoverHistorics.sagas';
export { actions, reducer };
